var CHECKOUT_TYPE_ANNOTATION_JOIN = 'new';
var CHECKOUT_TYPE_ANNOTATION_RESUB = 'resubscribe';
var CHECKOUT_TYPE_ANNOTATION_DOWNG = 'downgrade';
var CHECKOUT_TYPE_ANNOTATION_UPG = 'upgrade';
export { CHECKOUT_TYPE_ANNOTATION_JOIN, CHECKOUT_TYPE_ANNOTATION_RESUB, CHECKOUT_TYPE_ANNOTATION_DOWNG, CHECKOUT_TYPE_ANNOTATION_UPG };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/constants/CheckoutTypeAnnotation.js
// module id = 4690
// module chunks = 11